import { ProjectsSearchAccordionProvider } from '@/features/search/_components/projects/_common/ProjectsSearchAccordionProvider';
import { ProjectsSearchAccordion } from '@/features/search/_components/projects/search/ProjectsSearchAccordion';
import { useProjectListSearchQueryStates } from '@/features/search/_hooks/projects-search';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import type { FC, PropsWithChildren } from 'react';
import type {
  ProjectsSearchAccordionProviderType,
  ProjectsSearchSubmitType,
} from '../../../_utils/projects-search';

type Props = {
  initialFiscalYear?: string;
  onSubmit: (values: ProjectsSearchSubmitType) => Promise<void>;
  type: ProjectsSearchAccordionProviderType;
  forceInitialValues?: Partial<ProjectSearchFormType>;
};

export const ProjectsSearch: FC<PropsWithChildren<Props>> = (props) => {
  const { searchQueryStates } = useProjectListSearchQueryStates();
  return (
    <ProjectsSearchAccordionProvider
      type={props.type}
      searchQueryStates={searchQueryStates}
    >
      <SearchAccordion {...props} />
    </ProjectsSearchAccordionProvider>
  );
};

const SearchAccordion: FC<PropsWithChildren<Props>> = ({
  onSubmit,
  initialFiscalYear,
  children,
  forceInitialValues,
}) => {
  return (
    <ProjectsSearchAccordion
      onSubmit={onSubmit}
      initialFiscalYear={initialFiscalYear}
      forceInitialValues={forceInitialValues}
    >
      {children}
    </ProjectsSearchAccordion>
  );
};
